module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.下载APP并注册\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者可以通过理财师分享的二维码下载投资者APP，根据实际情况选择自然人或机构注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.点击快速注册\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者进入APP登录页面，点击“快速注册”，进行注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.服务协议及隐私协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者注册前需要对网络服务协议和隐私协议进行确认，“同意并确认”后才能注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.填写注册信息\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t自然人：填写手机号码、短信验证码、登录密码、确认登录密码\n\t\t\t\t"), _c('br'), _vm._v(" 机构：填写机构名称、组织机构代码\\统一社会信用代码、经办人手机号码、短信验证码、登录密码、确认密码\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.注册成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写信息完成后，点击“提交”，提示注册成功\n\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f43f1658"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/registerGuide.vue
// module id = 1095
// module chunks = 1